<mat-dialog-content class="fullscreen-dialog">
  <mat-toolbar class="fullscreen-toolbar" color="primary">
    Confirm Despatch
  </mat-toolbar>
  <div class="container">
    <br />
    <p>Despatch ticket?</p>


  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="dialogRef.close(false)" mat-flat-button
          type="button">{{ 'scheduler.general.cancel' | translate }}
  </button>
  <button (click)="dialogRef.close(true)" color="primary" mat-flat-button
          type="button">OK
  </button>
</mat-dialog-actions>
